import React from "react";
import AppModal from "./AppModal";

const EventDetail = ({ event }) => {
  return (
    <AppModal
      activator={
        <div className="w-[250px] lg:w-[474px] mx-auto cursor-pointer">
          <div
            className="h-[150px] lg:h-[250px] md:mt-12 w-full md:mx-auto bg-cover bg-no-repeat bg-center border-4 hover:border-salmon with-transition"
            style={{
              backgroundImage: `url(${event.cardImg})`,
            }}
          />
          <div className="text-start font-tw bg-salmon flex flex-col justify-center h-52 lg:h-36 px-4 my-auto w-full md:mx-auto">
            <h3 className="text-2xl font-bold uppercase">{event.title}</h3>
            <p className="py-2 font-bold">{event.price}</p>
            <p>{event.date}</p>
          </div>
        </div>
      }
      className=" lg:max-w-4xl max-h-screen"
    >
      <div className="bg-white grid justify-center pt-14 md:pt-0 pb-3">
        <div>
          <div
            className={`grid place-items-center w-full h-[171px] md:h-[306px] mb-6 bg-no-repeat bg-center bg-cover ${event.styleImgModal}`}
            style={{
              backgroundImage: `url(${event.imgModal})`,
            }}
          />
        </div>
        <div className="px-4 lg:px-14">
          <h4 className="text-primary uppercase text-4xl text-start font-sylfaen">
            {event.title}
          </h4>
          <span className="block bg-secondary w-full lg:w-[516px] mx-auto lg:mx-0 h-[1px] my-1" />
          <p className="mb-5 text-start uppercase">
            {event.date}
            <span className="block lg:inline-block font-bold lg:pl-2 pt-1">
              {event.price}
            </span>
          </p>
          <div className="pb-8">
            <p className="text-start">{event.descripcion}</p>
            <a
              href={event.link}
              target="_blank"
              rel="noreferrer"
              className="bg-secondary font-bold uppercase font-tw text-center py-3 w-full lg:w-72 mt-5 block mx-0 hover:bg-primary hover:text-white with-transition"
            >
              Get your tickets from here
            </a>
          </div>
        </div>
      </div>
    </AppModal>
  );
};

export default EventDetail;
